import { FileDownloadOutlined as FileDownloadOutlinedIcon } from '@mui/icons-material';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

import type { FunctionComponent } from 'react';

type ExportButtonProps = {
    readonly ariaLabel?: string;
    readonly isDisabled?: boolean;
    readonly isPending?: boolean;
    readonly label: string;
    readonly onClick: () => void;
};

export const ExportButton: FunctionComponent<ExportButtonProps> = ({
    ariaLabel,
    isDisabled,
    isPending,
    label,
    onClick,
}) => (
    <Button
        aria-label={ariaLabel}
        color="secondary"
        disabled={isDisabled === true || isPending === true}
        startIcon={isPending === true ? <CircularProgress size={20} /> : <FileDownloadOutlinedIcon />}
        sx={{
            '&.Mui-disabled': {
                color: isPending === true ? 'primary.main' : 'action.disabled',
            },
        }}
        variant="text"
        onClick={onClick}
    >
        {label}
    </Button>
);
